import { Modal } from '@components/alfakher/pylot-ui'
import { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'
import { Button } from '@corratech/pylot-ui'
import { DEFAULT_AGE } from '@components/checkout/DateOfBirth/DateOfBirthConfig'
import s from './AgeValidationPopup.module.scss'

export const AgeValidationPopup = () => {
    const [
        isAgeVerificationPopupEnabled,
        setIsAgeVerificationPopupEnabled
    ] = useState(false)
    const [isUnderage, setIsUnderage] = useState(false)
    const { t } = useTranslation(['common'])

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const ageAccepted = (localStorage.getItem(
                'ag_accepted'
            ) as unknown) as number
            if (!ageAccepted || findAgeDiff(ageAccepted)) {
                setIsAgeVerificationPopupEnabled(true)
            }
        }
    }, [])

    const findAgeDiff = (ageAccepted: number) => {
        const diffInMs =
            Date.now() - new Date(Number(ageAccepted) * 1000).getTime()
        const diffInHours = diffInMs / (1000 * 60 * 60)
        return diffInHours > 6
    }

    const handleNoClick = () => {
        setIsUnderage(true)
    }

    const handleCloseClick = () => {
        setIsUnderage(false)
        setIsAgeVerificationPopupEnabled(true)
    }

    if (!isAgeVerificationPopupEnabled) return null

    return (
        <Modal
            open={isAgeVerificationPopupEnabled}
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onClose={() => {}}
            className={s.AgeValidationPopup}
        >
            {isUnderage ? (
                <div className={s.content}>
                    <div className={s['age-close-text-wrapper']}>
                        <span className={s.bold}>
                            {t('You must be {{age}} or older', {
                                age: DEFAULT_AGE
                            })}
                        </span>
                    </div>
                    <div className={s.buttons}>
                        <Button variant="primary" onClick={handleCloseClick}>
                            {t('Close')}
                        </Button>
                    </div>
                </div>
            ) : (
                <div>
                    <div className={s.content}>
                        <span className={s.bold}>
                            {t('Are you {{age}} or older?', {
                                age: DEFAULT_AGE
                            })}
                        </span>
                    </div>
                    <div className={s.buttons}>
                        <Button
                            variant="none"
                            className={s['button-black']}
                            onClick={handleNoClick}
                        >
                            {t('No')}
                        </Button>
                        <Button
                            variant="primary"
                            onClick={() => {
                                setIsAgeVerificationPopupEnabled(false)
                                localStorage.setItem(
                                    'ag_accepted',
                                    String(Math.floor(Date.now() / 1000))
                                )
                            }}
                        >
                            {t('Yes')}
                        </Button>
                    </div>
                    <div className={s['age-validation-bottom-content']}>
                        {t(
                            'This website is restricted to users {{age}} years of age or older only. Please confirm that you are of legal age.',
                            {
                                age: DEFAULT_AGE
                            }
                        )}
                    </div>
                </div>
            )}
        </Modal>
    )
}
